import Cookies from "js-cookie";

export function clearCookies() {
  Cookies.remove("userData");
  Cookies.remove("userError");
}
